import React, { createContext, useContext, useState, useEffect } from 'react';
import en from '../data/language_en.json';
import pt from '../data/language_pt.json';

const translations = { en, pt };
const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  // Load saved language or fallback to 'pt'
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('appLanguage') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('appLanguage', language);
  }, [language]);

  const t = (key) => {
    // Support nested keys like "clientsTable.matterName"
    return key.split('.').reduce((obj, part) => obj?.[part], translations[language]) || key;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  return (
    <TranslationContext.Provider value={{ t, changeLanguage, language }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);
